import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class StandardModifierService {
  constructor(http) {
    this.http = http;
    this.singular = 'standard modifier';
    this.plural = 'standard modifiers';
    this.editor = PLATFORM.moduleName('pages/standard-setup/standard-modifiers/editor/index');
  }

  async filter(loadOptions) {
    const response = await this.http.fetch(`standard-modifiers/filter/${loadOptions}`);
    return await response.json();
  }

  async create(standardMultiplier) {
    const response = await this.http.fetch('standard-modifiers', { method: 'POST', body: json(standardMultiplier) });
    return await response.json();
  }

  async update(standardMultiplier) {
    await this.http.fetch(`standard-modifiers/${standardMultiplier.id}`, { method: 'PUT', body: json(standardMultiplier) });
  }

  async delete(id) {
    await this.http.fetch(`standard-modifiers/${id}`, { method: 'DELETE' });
  }

  async getById(id) {
    const response = await this.http.fetch(`standard-modifiers/${id}`);
    return await response.json();
  }
}